/*
 * Delete this file when cleaning up editor_ai_cmd_palette_remove_retry
 * if we choose to release the experiment.
 */

import { defineMessages } from 'react-intl-next';

export default defineMessages({
	retryPrompt: {
		id: 'fabric.editor.ai.config.item.action.retryPrompt',
		defaultMessage: 'Retry',
		description: 'Retry the latest prompt',
	},
});
